module.exports = __webpack_public_path__ + "img/chongci_ps_31.ac7ebe38.jpg";